const OFFSET_PARAM_NAME = 'No';
const PRODUCTS_PER_PAGE_PARAM_NAME = 'Nrpp';
const NAVIGATION_STATE_PARAM_NAME = 'N';
const BUSINESS_ID_PARAM_NAME = 'businessId';
const SELECTED_NODE_ID = 'selected-node-id';
const DEFAULT_NAVIGATION_STATE = '726se132';

export { BUSINESS_ID_PARAM_NAME as B, DEFAULT_NAVIGATION_STATE as D, NAVIGATION_STATE_PARAM_NAME as N, OFFSET_PARAM_NAME as O, PRODUCTS_PER_PAGE_PARAM_NAME as P, SELECTED_NODE_ID as S };
